/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */


import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ItemsService } from '../services/items.service';
declare var $: any;

@Component({
    selector: 'zsd-items',
    templateUrl: '../view/items.component.html',
    encapsulation: ViewEncapsulation.None
})

export class ItemsComponent implements OnInit {
    isFilterOpen: boolean;
    itemResultsCount: String;

    constructor(private itemService: ItemsService) {
        this.itemService.getItemResultsCount().subscribe((val: number) => {
            this.itemResultsCount = '(' + val + ')';
        });
    }

    ngOnInit() {
        window.scrollTo(0, 0);
    }

    openFilter() {
        this.isFilterOpen = true;
        $('#items_filterpanel_control').width('100%');
        $('body').css('overflow-y', 'hidden');
    }
}
